<div class="error">
  <span class="error__title">{{'An unexpected error occurred.' | translate}}</span>
  <span *ngIf="!showAction" class="error__description">{{'Try again later!' | translate}}</span>

  <div class="error__action">
    <button (click)="refreshed.emit()"
            *ngIf="showAction"
            class="mat-button button--white button--refresh">
      <mat-icon>refresh</mat-icon>
      <span>{{ 'Try again' | translate }}</span>
    </button>
  </div>

</div>
